import Text from 'components/Text/Text';
import React from 'react';
import { Checkbox, Form } from 'antd';

interface IProps {
	toggleHasSchedulePriority: () => void;
	hasSchedulePriority: boolean;
}

export const HasSchedulePriorityCheckBox: React.FC<IProps> = React.memo(
	({ toggleHasSchedulePriority, hasSchedulePriority }) => (
		<Form.Item name="hasSchedulePriority" data-test="HasSchedulePriorityCheckBox">
			<Checkbox checked={hasSchedulePriority} onChange={toggleHasSchedulePriority}>
				<Text translationNameSpace="form" translationKey="hasSchedulePriorityLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	),
);
